import React from "react";
import { useMaliciousIpList, useReleaseIP } from "../api/apiHooks";
import { useFilters } from "../../../system/hooks/useFilters";
import { usePagination } from "../../../system/hooks/usePagination";
import useDebounce from "../../../system/hooks/useDebounce";
import MaliciousIpTemplate from "./MaliciousIpTemplate";

const MaliciousIpContainer = () => {
  const { filter, setFilter } = useFilters({ searchValue: "" });
  const { page, setPage } = usePagination(1);

  const debouncedSearchValue: any = useDebounce(filter.searchValue, 1000);

  const {
    data: maliciousIpList,
    isFetching: isFetchingMaliciousIpList,
  } = useMaliciousIpList(debouncedSearchValue, page);

  const { mutate: mutateMaliciousIp } = useReleaseIP(
    debouncedSearchValue,
    page
  );

  const handleMaliciousIp = (id) => {
    mutateMaliciousIp(id);
  };

  const updateFilter = (val) => {
    setFilter({ searchValue: val });
    setPage(1);
  };

  return (
    <MaliciousIpTemplate
      data={maliciousIpList}
      isLoading={isFetchingMaliciousIpList}
      handleReleaseIp={handleMaliciousIp}
      filter={filter}
      setFilter={updateFilter}
      setPage={setPage}
      currentPage={page}
    />
  );
};

export default MaliciousIpContainer;
